import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import {Button, Form, Input} from "reactstrap";
import TextLabel from "../../../controls/TextLabel.mjs";
import MailIcon from "../../../media/assets/MailIcon.mjs";

const prefix = "UserIndex";

const UserSendOtp = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value || Glob.getStatus('emailToBeVerified') || '',
			lang: Glob.getLanguage()
		}
		this.setMail = this.setMail.bind(this)
		this.sendOtp = this.sendOtp.bind(this)
	}
	sendOtp() {
		this.setState({ sending: true}, async ()=> {
			let out = {};
			try {
				out = await appLib.api('auth/send-otp', { email: this.state.value });
			} catch (e) {
				out.error = e.message;
			}
			if ( out.sent ) {
				Glob.setStatus('emailToBeVerified', out.mail);
				Glob.trigger('otp_sent', true);
			}
			this.setState({ error: out.error || false, sending: false });
		});
	}
	setMail(m='') {
		m = m.replace(/[ \t\r\n]+/g,'');
		this.setState({value: m, valid: !! m.match(/^[^@]+@[^.@]+\.[^@]{2,}$/), error: false });
	}
	render() {
		return (
			<Form
				className={prefix+'-send-otp'}
				onSubmit={ e =>{
					e.preventDefault();
					if ( ! this.state.valid || this.state.sending ) return;
					this.sendOtp();
				}}
			>
				{ this.state.lang==='it' ? (
					<div lang={"it"} className={"mb-2"}>
						<p>
							<strong>Non serve registrarsi, puoi iniziare subito</strong>.
						</p>
						<p>
							L’accesso richiede solo una <strong>autenticazione</strong>.<br/>
							Per autenticarsi indicare il proprio indirizzo di email.
						</p>
					</div>
				) : (
					<div lang={"en"} className={"mb-2"}>
						<p>
							<strong>There’s no registration, you can start now</strong>.
						</p>
						<p>
							<strong>Authentication</strong> is enough for logging in.<br />
							To authenticate provide your actual email adddress.
						</p>
					</div>
				)}
				<h5>
					<TextLabel value={"Email"} />:
				</h5>
				<Input
					type="email"
					autoFocus={true}
					value={ this.state.value }
					autoComplete={"home email webauthn"}
					onChange={ e => this.setMail(e.target.value) }
				/>
				<Button
					color={"primary"}
					className="btn-icon"
					type="submit"
					disabled={ ! this.state.valid || this.state.sending }
				>
					<b>
						<TextLabel value={"Verify email"} />
					</b>
					<i>
						<MailIcon />
					</i>
				</Button>
				{ this.state.error && <div className="error">{ this.state.error }</div> }
				{ this.state.lang==='it' ? (
					<div lang={"it"} className={"mt-2"}>
						Riceverai a questa email un codice di verifica.
					</div>
				) : (
					<div lang={"en"} className={"mt-2"}>
						An One Time Password will be sent to your mailbox.
					</div>
				)}
			</Form>
		)
	}
}

export default UserSendOtp;
